// extracted by mini-css-extract-plugin
module.exports = {"actions":"CourseActions_actions__3K0FU"};